import { VehicleApi } from '../../infrastructure/api';
import { Vehicle } from '../../domain/entities';

export class SearchVehicleUseCase {
    async execute(plateOrCard: string, token: string): Promise<Vehicle | null> {
        if ((plateOrCard.length < 6 || plateOrCard.length > 7) && plateOrCard.length !== 16) {
            return null;
        }

        return await VehicleApi.fetchByPlateOrCard(plateOrCard, token);
    }
}

